// extracted by mini-css-extract-plugin
export var title = "AllTalksPage-module--title--ro45+";
export var container = "AllTalksPage-module--container--MqSWG";
export var talkList = "AllTalksPage-module--talkList--kMg-+";
export var talk = "AllTalksPage-module--talk--r-CrK";
export var cover = "AllTalksPage-module--cover--dSkKJ";